




































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// Components
import { Button, Card, Form, FormItem, Input } from 'element-ui';

// Types
import {
  ShipmentFields,
  ShipmentStatusEnum
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    'el-button': Button,
    'el-card': Card,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input
  }
})
export default class PaymentTermsUpsert extends Vue {
  @Prop({ required: true }) private shipment!: ShipmentFields;

  public terms: string | null = this.shipment.organizationPaymentTerms || null;
  public editing = false;
  public loading = false;

  @Watch('shipment.organizationPaymentTerms')
  private setData(terms: string | null) {
    this.terms = terms;
  }

  private resetToDefault() {
    this.terms = null;
    this.submit();
  }

  private resetData() {
    this.editing = false;
    this.terms = this.shipment.organizationPaymentTerms || null;
  }

  private resetUI() {
    this.editing = false;
    this.loading = false;
  }

  private async submit() {
    this.loading = true;
    let dispatchName = 'Inquiry/updateInquiry';

    if (this.shipment.status in ShipmentStatusEnum) {
      dispatchName = 'Shipment/updateShipment';
    }

    this.$store.dispatch(dispatchName, {
      id: this.shipment.id,
      organizationPaymentTerms: this.terms
    }).then(this.resetUI, this.resetUI);
  }
}

